
export interface IPublicTypeDragAnyObject {
  type: string;
  [key: string]: any;
}
